import * as React from "react";
import { makeStyles } from "@mui/styles";
import { useRef } from "react";
import Button from "@mui/material/Button";
import CartonProductionJobLineItemBreakdownTable from "../CartonProductionJobLineItemBreakdownTable";
import Divider from "@mui/material/Divider";
import ExpeditingLabelViewer from "../../../../../components/ExpeditingLabelViewer";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles(theme => ({
  descriptionList: {
    textAlign: "left",
    verticalAlign: "top"
  },

  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },

  productionJobDetailWrapper: {
    textAlign: "left",
    justifyContent: "left"
  },

  primaryCustomerName: {
    marginRight: theme.spacing(1)
  },

  headerWrapper: {
    display: "flex",
    justifyContent: "space-between"
  },

  productionJobLabel: {
    fontWeight: theme.typography.fontWeightMedium
  },

  productionJobLineItemBreakdownTable: {
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(2)
  },

  wrapper: {
    padding: theme.spacing(2)
  }
}));

const pluralize = require("pluralize");

const BulkReceivingDetailView = ({ cartonProductionJob }) => {
  const classes = useStyles();
  const printRef =useRef(null);

  let productionJob = cartonProductionJob;

  const handlePrintRef = ref => {
    if (printRef.current === null) {
      printRef.current = ref;
    }
  }

  const handlePrintLabelButtonClick = event => {
    event.stopPropagation();
    if (printRef.current) {
      printRef.current();
    }
  };

  return (
    <div>
      <div className={classes.wrapper}>
        <div className={classes.headerWrapper}>
          <div className={classes.descriptionList}>
            <Typography className={classes.primaryCustomerName} variant="body1">
              {productionJob.order.primaryCustomer.name}
            </Typography>
            <Typography
              color="textSecondary"
              style={{ marginBottom: 5 }}
              variant="subtitle2"
            >
              {productionJob.order.orderNumber}
            </Typography>
          </div>
          <div className={classes.descriptionList}>
            <Button
              variant="contained"
              color="primary"
              onClick={handlePrintLabelButtonClick}
            >
              Print Staging Label
            </Button>
          </div>
        </div>
        <div className={classes.productionJobDetailWrapper}>
          <Typography className={classes.productionJobLabel} variant="body1">
            {productionJob.label}
          </Typography>
          <div>
            <Typography color="textSecondary" variant="subtitle2">
              {`${Object.entries(productionJob.lineItemsByGtin).reduce((acc, [, { cartonQuantity }]) => acc + cartonQuantity, 0)} of ${pluralize(
                "Piece",
                productionJob.totalProductVariantQuantity,
                true
              )}`}
            </Typography>
          </div>
        </div>
        <React.Fragment>
          <ExpeditingLabelViewer
            autoPrint={false}
            isResolution={productionJob.order.isResolution}
            productionJobs={[productionJob]}
            printRef={handlePrintRef}
            hidden={true}
            priority={productionJob.order.priority}
            includeCatalogInShipment={productionJob.order.includeCatalogInShipment}
            productionStationAssignment={
              productionJob.order.productionStationAssignments.length >
                0
                  ? productionJob.order.productionStationAssignments[0]
                      .productionStation.name
                  : undefined
            }
            shipMissCosts={productionJob.order.shipMissCosts}
            shippingMethodName={
              productionJob.order.shippingTransactions.length
                ? productionJob.order.shippingTransactions[0].shippingMethod?.name
                : null
            }
          />
        </React.Fragment>
        <Divider light={true} className={classes.divider} />
        {productionJob.lineItemBreakdownByProduct
          .filter(
            ({ product: { isStyleSubstitution }, lineItems }) =>
              !isStyleSubstitution &&
              lineItems.some(({ sizes }) =>
                sizes.some(
                  ({ gtin }) =>
                    productionJob.lineItemsByGtin[gtin] &&
                    productionJob.lineItemsByGtin[gtin].cartonQuantity > 0
                )
              )
          )
          .map(productionJobLineItemBreakdown => (
            <div
              className={classes.CartonproductionJobLineItemBreakdownTable}
              key={productionJobLineItemBreakdown.product.id}
            >
              <Typography variant="body2">
                {`${productionJobLineItemBreakdown.product.style} - `}
                {productionJobLineItemBreakdown.product.fullDisplayName}
              </Typography>
              <CartonProductionJobLineItemBreakdownTable
                lineItems={productionJobLineItemBreakdown.lineItems}
                lineItemsByGtin={productionJob.lineItemsByGtin}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default BulkReceivingDetailView;
